export default "__VITE_ASSET__0b4cd0ec__"